import { Loading, Markdown } from "@quark/design";
import { FC, useEffect, useState } from "react";
import { genCodePrompt, replyApiUrl } from "../../api";
import { CodePrompt } from "../../types/code";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { mdFix } from "../../utils/chatgpt";

interface ErrorHelpProps {
  prompt: CodePrompt;
}

const CodeErrorHelp: FC<ErrorHelpProps> = ({ prompt }) => {
  const [helpMd, setHelpMd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const showHelp = async () => {
    try {
      setLoading(true);
      setErrMsg("");
      const { prompt: helpPrompt } = await genCodePrompt(prompt);

      const ctrl = new AbortController();
      fetchEventSource(replyApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prompt: helpPrompt,
        }),
        signal: ctrl.signal,
        onmessage: (ev) => {
          const { code, type, content } = JSON.parse(ev.data);
          if (code === 0 && type === "markdown") {
            setHelpMd(mdFix(content));
          } else {
            setErrMsg(content);
          }
        },
        onerror: (_err) => {
          document.dispatchEvent(new Event("visibilitychange"));
          ctrl.abort();
        },
      });
    } catch (e) {
      //
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showHelp();
    // eslint-disable-next-line
  }, [prompt]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Markdown children={helpMd}></Markdown>
          {!!errMsg && <p>{errMsg}</p>}
        </>
      )}
    </>
  );
};

export default CodeErrorHelp;
